import { render } from "./ProfilePanel.vue?vue&type=template&id=25b2017e&scoped=true"
import script from "./ProfilePanel.vue?vue&type=script&lang=js"
export * from "./ProfilePanel.vue?vue&type=script&lang=js"

import "./ProfilePanel.vue?vue&type=style&index=0&id=25b2017e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b2017e"]])

export default __exports__